import { AlkLogger } from '@alk/core';
import { getCurrenciesFromCurrencyPair } from '@alk/currency';
import isEqual from 'lodash/isEqual';
export const isChildrenWithSameCurrencyPair = (key) => (params) => {
    if (!params.node.group) {
        return true;
    }
    const refCurrencyPair = getCurrenciesFromCurrencyPairSafe(params.node.allLeafChildren[0].data[key]);
    return params.node.allLeafChildren.every((value) => isEqual(refCurrencyPair, getCurrenciesFromCurrencyPairSafe(value.data[key])));
};
export const getCurrenciesFromCurrencyPairSafe = (currencyPair) => {
    try {
        return getCurrenciesFromCurrencyPair(currencyPair);
    }
    catch (err) {
        AlkLogger.warn(err);
        return null;
    }
};
